import { useState } from "react";

export const usePagination = () => {
    const [pageNumber, setPageNumber] = useState(1);

    return { pageNumber, setPageNumber }
}